import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface SidebarState {
  collapsed: boolean
}

const initialState: SidebarState = {
  collapsed: false
}

const sidebarSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    toggle: (state) => {
      state.collapsed = !state.collapsed
    },
    setCollapsed: (state, action: PayloadAction<boolean>) => {
      state.collapsed = action.payload
    }
  }
})

export const { toggle, setCollapsed } = sidebarSlice.actions
export default sidebarSlice.reducer 